/**
 * Rank-up ceremony — the "wow" moment. Full-screen, understated, like a real
 * system authorization change (guide §3.5 + the operator's mockup state 3).
 * Holds ~15s, then calls onDone. No confetti, no sound beyond JARVIS's voice.
 */
import { useEffect, useState } from "react";
import RankInsignia from "./RankInsignia";

export default function RankUp({
  fromRank,
  toRank,
  holdMs = 15000,
  onDone,
}: {
  fromRank: string;
  toRank: string;
  holdMs?: number;
  onDone: () => void;
}) {
  // Letter-by-letter print of the new rank (security-terminal feel).
  const full = toRank.toUpperCase();
  const [shown, setShown] = useState(0);
  // Insignia theater: old mark gets STAMPED FLAT, new one arrives coin-spinning.
  const [phase, setPhase] = useState<"flatten" | "arrive">("flatten");

  useEffect(() => {
    const arrive = setTimeout(() => setPhase("arrive"), 1500);
    let printer: ReturnType<typeof setInterval> | null = null;
    const startPrint = setTimeout(() => {
      printer = setInterval(() => {
        setShown((n) => (n >= full.length ? n : n + 1));
      }, 90);
    }, 1700); // rank prints once the new insignia has landed
    const done = setTimeout(onDone, holdMs);
    return () => {
      clearTimeout(arrive);
      clearTimeout(startPrint);
      if (printer) clearInterval(printer);
      clearTimeout(done);
    };
  }, [full.length, holdMs, onDone]);

  return (
    <div className="kid-rankup" role="alert">
      <div className="kid-rankup__former">
        ANCIENNE DÉSIGNATION : {fromRank.toUpperCase()} ISAAC
      </div>

      <div className="kid-rankup__stage">
        {phase === "flatten" ? (
          <div className="kid-rankup__old">
            <RankInsignia rank={fromRank} size={72} />
          </div>
        ) : (
          <div className="kid-rankup__new">
            <RankInsignia rank={toRank} size={92} />
            <span className="kid-rankup__shine" />
          </div>
        )}
      </div>

      <div className="kid-rankup__frame">
        <span className="kid-corner kid-corner--tl" />
        <span className="kid-corner kid-corner--tr" />
        <span className="kid-corner kid-corner--bl" />
        <span className="kid-corner kid-corner--br" />
        <div className="kid-rankup__label">MISE À JOUR D'HABILITATION</div>
        <div className="kid-rankup__rank">
          {full.slice(0, shown)}
          <br />
          ISAAC
        </div>
      </div>

      <div className="kid-rankup__footer">TON PÈRE SERA INFORMÉ</div>
    </div>
  );
}
